import Wizard from './Wizard';
import WizardFooter from './WizardFooter/WizardFooter';

export * from './Wizard.types';

export default { Wizard, WizardFooter };
